import { render } from "./beranda-saran-masukan.vue?vue&type=template&id=6330353e&scoped=true"
import script from "./beranda-saran-masukan.vue?vue&type=script&lang=js"
export * from "./beranda-saran-masukan.vue?vue&type=script&lang=js"

import "./beranda-saran-masukan.vue?vue&type=style&index=0&id=6330353e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6330353e"]])

export default __exports__